import React, { useEffect, useState } from "react";
import { Button, Card, Skeleton, Table } from "antd";
import { useAccount } from "src/hooks/account.hook";
import { Transaction } from "src/models/account";
import { NewtransactionModal } from "src/components/new-transaction";
import { DetailransactionModal } from "src/components/detail-transaction";
import { EyeOutlined } from "@ant-design/icons";
import * as FormatUtils from "../utils/format";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useAtom } from "jotai";
import { accountAtom } from "src/store";
import { usePageTracking } from "src/hooks/tracking-page.hook";

export default function Transactions() {
  const { getTransactionsHitory } = useAccount();
  const [transactionsLoading, setTransactionsLoading] =
    useState<boolean>(false);
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isModalDetailOpen, setIsModalDetailOpen] = useState<boolean>(false);
  const [pagination, setPagination] = useState<any>(null);
  const [transaction, setTransaction] = useState<Transaction>();
  const [account] = useAtom(accountAtom);
  const { trackPage } = usePageTracking();

  const { t } = useTranslation("transactions");

  useEffect(() => {
    getProducts();
  }, [account]);

  useEffect(() => {
    if (pagination) {
      trackPage(pagination);
    }
  }, [pagination]);

  useEffect(() => {
    if (transactions.length > 0) {
      setPagination({
        page_number: 1,
        pages_total: transactions.length,
      });
    }
  }, [transactions]);

  const getProducts = () => {
    setTransactionsLoading(true);
    setTransactions([]);
    getTransactionsHitory({ userId: account?.id })
      .then((value) => setTransactions(value))
      .finally(() => setTransactionsLoading(false));
  };

  const selectTransaction = (data: Transaction) => {
    setTransaction(data);
    setIsModalDetailOpen(true);
  };
  const transactionHistorycolumns = [
    {
      title: t("date"),
      key: "date_effect",
      render: (_: any, record: any) => (
        <>{moment(record?.date_effect).format("DD-MM-YYYY")}</>
      ),
    },
    {
      title: t("name"),
      dataIndex: "product_name",
      key: "product_name",
    },

    {
      title: t("productType"),
      dataIndex: "product_type",
      key: "product_type",
    },
    {
      title: t("operationType"),
      dataIndex: "operation_type",
      key: "operation_type",
    },
    {
      title: t("amountNet"),
      key: "amount_net",
      render: (_: any, record: any) => (
        <>{FormatUtils.currency.format(record?.amount_net)}</>
      ),
    },
    {
      title: t("fee"),
      key: "fee",
      render: (_: any, record: any) => (
        <>{FormatUtils.currency.format(record?.fee)}</>
      ),
    },
    {
      title: t("status"),
      dataIndex: "operation_status",
      key: "operation_status",
    },

    {
      title: "",
      key: "action",
      render: (_: any, transaction: Transaction) => (
        <Button
          icon={<EyeOutlined />}
          onClick={() => selectTransaction(transaction)}
        ></Button>
      ),
    },
  ];
  return (
    <>
      <div>
        <Card
          hoverable
          className="flex justify-center items-center mt-8 w-full bg-op"
        >
          <div className="flex justify-between w-full flex-col md:flex-row">
            <h2 className="text-center lg:text-xl font-bold">
              {t("transactionListLabel")}
            </h2>
            <Button
              className="mt-2 md:mt-o"
              disabled={transactionsLoading}
              onClick={() => setIsModalOpen(true)}
            >
              {t("newTransactionLabel")}
            </Button>{" "}
          </div>
          <div className="w-full flex justify-center w-full mt-5">
            {transactionsLoading ? (
              <Skeleton paragraph={{ rows: 4 }} />
            ) : (
              <Table
                columns={transactionHistorycolumns}
                dataSource={transactions}
                className="w-full bg-op"
                rowClassName={"bg-op"}
                rootClassName="bg-op"
                scroll={{ x: 1000, y: 300 }}
                onChange={(pagination) => {
                  setPagination({
                    page_number: pagination?.current || 1,
                    pages_total: transactions.length,
                  });
                }}
              />
            )}
          </div>
        </Card>
      </div>
      <NewtransactionModal
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
      <DetailransactionModal
        isModalOpen={isModalDetailOpen}
        transaction={transaction}
        closeModal={() => setIsModalDetailOpen(false)}
      />
    </>
  );
}
